import { Spin } from 'antd';
import { get } from 'lodash';
import React from 'react';
import { useParams } from 'react-router-dom';
import { Form, OriSelect, RadioGroup, RadioItem } from 'src/components/Antd';
import { useI18n } from 'src/hooks/useRouterChange';
import { getDeliveryMethods } from 'src/request/salesChannel/discounts/directDiscount';
import { i18nGet } from 'src/tools/tools';
// import CustomerTable from '../CustomerTable';
import css from './css.module.less';

const Item = Form.Item;
export enum ECondition {
  All = 'All',
  Specific = 'Specific',
}

const DeliveryMethod = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const { uuid }: any = useParams();
  const [loaded, setLoaded] = React.useState(false);
  const {
    radioName,
    methodsName,

    disableEdit,
    // disabledEveryoneDependency,
  } = props;
  ///portal/salesChannelDeliveryMethods/{{salesChannelUuid}}
  const [methods, setMethods] = React.useState([]);
  React.useEffect(() => {
    getDeliveryMethods(uuid).then((data: any) => {
      const deliveryMethods = get(data, 'deliveryMethods');
      const lockers = get(data, 'lockers');

      const deliveryOptions = (deliveryMethods || []).map((i) => {
        const label = get(i, 'storeDeliveryMethod.name');
        const uuid = get(i, 'storeDeliveryMethod.uuid');
        const type = 'Delivery';
        return { label, uuid, type };
      });
      const lockerOptions = (lockers || []).map((i) => {
        const label = get(i, 'storeParcelLocker.name');
        const uuid = get(i, 'storeParcelLocker.uuid');
        const type = 'ParcelLocker';
        return { label, uuid, type };
      });
      const methodOptions = [...deliveryOptions, ...lockerOptions];
      setMethods(methodOptions);
      setLoaded(true);
    });
  }, []);

  //   const _base = 'customerCondition';
  //   const _type = [_base, 'conditionType'];
  //   const _customer = [_base, 'customers'];
  //   const _tags = [_base, 'customerTags'];
  return (
    <Spin spinning={!loaded}>
      <React.Fragment>
        <Item
          name={radioName}
          rules={[
            {
              required: true,
              message: getI18n('general.pleaseselectavalue'),
            },
          ]}>
          <RadioGroup className={css.radioGroup} disabled={disableEdit}>
            <RadioItem className={css.radio} value={ECondition.All}>
              {getI18n(
                'salesChannelDirectDiscount.deliveryMethod.alldeliverymethods',
              )}
            </RadioItem>
            <RadioItem value={ECondition.Specific} className={css.radioLast}>
              {getI18n(
                'salesChannelDirectDiscount.deliveryMethod.specificdelierymethod',
              )}
            </RadioItem>
          </RadioGroup>
        </Item>

        <Item
          shouldUpdate={(p, c) => {
            const pV = get(p, radioName);
            const cV = get(c, radioName);
            return pV !== cV;
          }}>
          {({ getFieldValue }) => {
            const isDisplay = getFieldValue(radioName) === ECondition.Specific;
            if (isDisplay) {
              return (
                <div className={css.customerSelectionContainer}>
                  <Item
                    name={methodsName}
                    rules={[
                      {
                        validator: async (x, value) => {
                          if ((value || []).length === 0) {
                            return Promise.reject(
                              new Error(
                                getI18n(
                                  'general.advancedFilters.commonRadioMulSelect.selectItem',
                                ),
                              ),
                            );
                          }
                        },
                      },
                    ]}>
                    <_Methods options={methods} disabled={disableEdit} />
                  </Item>
                </div>
              );
            }
            return null;
          }}
        </Item>
      </React.Fragment>
    </Spin>
  );
};
export default DeliveryMethod;
const _Methods = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const { value, onChange, id, options, disabled } = props;
  const uuids = (value || []).map((i) => get(i, 'uuid'));

  const handleOnChange = (e) => {
    const obj = (e || []).map((uuid) => {
      return (options || []).find((i) => get(i, 'uuid') === uuid);
    });
    onChange(obj);
  };

  const formatOptions = React.useMemo(() => {
    const d = (options || []).filter((i) => get(i, 'type') === 'Delivery');
    const l = (options || []).filter((i) => get(i, 'type') === 'ParcelLocker');
    return [
      {
        label: getI18n('salesChannelDirectDiscount.deliveryMethod.delivery'),
        options: d.map((i) => {
          return {
            label: get(i, 'label'),
            value: get(i, 'uuid'),
          };
        }),
      },
      {
        label: getI18n(
          'salesChannelDirectDiscount.deliveryMethod.parcelLocker',
        ),
        options: l.map((i) => {
          return {
            label: get(i, 'label'),
            value: get(i, 'uuid'),
          };
        }),
      },
    ];
  }, [options]);

  return (
    <OriSelect
      id={id}
      size='large'
      mode='multiple'
      value={uuids}
      onChange={(e) => {
        //const obj = (options || []).find((i) => get(i, 'uuid') === e);
        handleOnChange(e);
      }}
      disabled={disabled}
      //placeholder={getI18n('general.advancedFilters.customerTag.placeholder')}
      showSearch
      filterOption={(input, option) => {
        return (
          (option.children || '').toLowerCase().indexOf(input.toLowerCase()) >=
          0
        );
      }}
      options={formatOptions}>
      {/* {(options || []).map((i) => {
        const { uuid, label } = i;
        return (
          <OriSelect.Option value={uuid} key={uuid}>
            {label}
          </OriSelect.Option>
        );
      })} */}
    </OriSelect>
  );
};
